import React from "react";
import Recorder from "../../components/video-recorder/index";
import { useProcess } from "../../contexts/ProcessContext";
import { useTranslation } from "react-i18next";

import "./styles.scss";

const RecorderTest = ({ ...props }) => {
  const { interviewInfo } = useProcess();
  const { t } = useTranslation();

  return (
    <div className="pd">
      <div
        style={{
          padding: "3rem",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: "1rem",
          boxShadow: "2px 2px 8px 0px #00000029",
          borderRadius: 8,
          background: "#FFFFFF",
          width: "min(90%, 600px)",
        }}
      >
        <span
          style={{ color: "#5E5E5E", fontSize: "1.5rem", fontWeight: "600" }}
        >
          {t("frontvint__test_audio_video_title")}
        </span>
        <span style={{ color: "#5E5E5E" }}>
          {t("frontvint__test_audio_video_description")}
        </span>

        <Recorder
          time={10}
          className="video-js"
          demo={true}
          questionId={"questionid-test"}
          candidateId={"candidateid-test"}
          interviewId={"interviewid-test"}
          trials={2}
        />
      </div>
    </div>
  );
};

export default RecorderTest;
